import { Capacitor } from "@capacitor/core";

const openExternal = async (url: string): Promise<void> => {
  if (Capacitor.isNativePlatform()) {
    const { AppLauncher } = await import("@capacitor/app-launcher");
    await AppLauncher.openUrl({ url });
  } else {
    window.open(url, "_blank");
  }
};

export default openExternal;
